export const getError = ( err) => {
    return 'Ocorreu um erro';
}